import React, { Children } from 'react';
import { useInView } from '../../hooks/useInView';
interface AnimateProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
  style?: CSSProperties;
  as?: keyof JSX.IntrinsicElements;
}
export function Animate({
  children,
  className = '',
  delay = 0,
  direction = 'up',
  style,
  as: Tag = 'div'
}: AnimateProps) {
  const [ref, inView] = useInView();
  const directionOffset: Record<string, string> = {
    up: 'translateY(24px)',
    down: 'translateY(-24px)',
    left: 'translateX(40px)',
    right: 'translateX(-40px)',
    none: 'none'
  };
  const baseStyle: CSSProperties = {
    opacity: inView ? 1 : 0,
    transform: inView ? 'none' : directionOffset[direction],
    transition: `opacity 0.5s ease ${delay}s, transform 0.5s ease ${delay}s`,
    willChange: inView ? 'auto' : 'opacity, transform',
    ...style
  };
  return (
    // @ts-ignore
    <Tag ref={ref} className={className} style={baseStyle} data-id="element-125">
      {children}
    </Tag>
  );
}
interface StaggerProps {
  children: ReactNode;
  className?: string;
  staggerDelay?: number;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
}
export function Stagger({
  children,
  className = '',
  staggerDelay = 0.1,
  direction = 'up'
}: StaggerProps) {
  const [ref, inView] = useInView();
  const items = Children.toArray(children);
  return <div ref={ref} className={className} data-id="element-126">
      {items.map((child, i) => {
      const delay = i * staggerDelay;
      return <div key={i} style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'none' : direction === 'up' ? 'translateY(24px)' : direction === 'left' ? 'translateX(40px)' : 'none',
        transition: `opacity 0.5s ease ${delay}s, transform 0.5s ease ${delay}s`,
        willChange: inView ? 'auto' : 'opacity, transform'
      }} data-id="element-127">
            {child}
          </div>;
    })}
    </div>;
}